import {
  SpotlightTarget,
  getAssetForEpicLink,
  getAssetOptionsForAssignee,
  getAssetOptionsForIssueType,
  getAssetOptionsForPriority
} from '../common';
import { FIRST_ISSUE_ID } from '../constants/ui';
import { useMessages } from '../state';
import { cardStyles } from './card.styles';
import { IntroTransition } from '../common/intro-transition';

export const Card = ({
  summary,
  epicName,
  issueType,
  priority,
  assignee,
  id
}: cardProps) => {
  const [messages] = useMessages();
  const epicLinkElement = getAssetForEpicLink(epicName);
  const issueTypeElement = getAssetOptionsForIssueType(
    issueType,
    messages,
    true
  );

  const priorityElement = getAssetOptionsForPriority(priority, messages, true);
  const assigneeElement = getAssetOptionsForAssignee(assignee, messages, true);

  const card = () => {
    return (
      <div css={cardStyles} id={'testid'}>
        <div className="label-container">{summary}</div>
        <div className="epic-link-row">{epicLinkElement}</div>
        <div className="type-priority-assignee-row">
          <div className="issue-type-container">
            {issueTypeElement}
            <div className="issue-text">{issueType}</div>
          </div>
          <div className="priority-assignee-container">
            <div className="">{priorityElement}</div>
            <div className="">{assigneeElement}</div>
          </div>
        </div>
      </div>
    );
  };

  // Conditionally render card wrapped in Transition and Spotlight components if we need to pulse it
  return id === FIRST_ISSUE_ID ? (
    <IntroTransition
      initialCSS="
              position: relative;
              top: 100px;
              opacity: 0.0;
            "
      transitionCSS="
              transition: all 1.0s ease-in-out;
            "
      finalCSS="
              top: 0px;
              opacity: 1.0;
            "
    >
      <SpotlightTarget name={id ?? ''}>{card()}</SpotlightTarget>
    </IntroTransition>
  ) : (
    card()
  );
};

export type cardProps = {
  summary: string | undefined;
  epicName: string | undefined;
  issueType: string | undefined;
  priority: string | undefined;
  assignee: string | undefined;
  id: string | undefined;
};
